<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <!-- 原有的单位类别Tab -->
        <el-form-item label="" v-if="isuse == 1 && !code">
          <el-tabs v-model="formInline.kmd_grade_id" @tab-click="handleTabClick">
            <el-tab-pane
              v-for="(item,index) in kmdGradeArr"
              :key="index"
              :label="item.name"
              :name="item.id.toString()">
            </el-tab-pane>
          </el-tabs>
        </el-form-item>

        <!-- 新增的VIP等级Tab - 当code为company时显示 -->
        <el-form-item label="" v-if="code === 'company' && qy_id==0" style="width: 100%;">
          <el-tabs v-model="formInline.grade_id" @tab-click="handleVipTabClick" class="vip-tabs">
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane label="游客" name="1"></el-tab-pane>
            <el-tab-pane label="个人VIP" name="3"></el-tab-pane>
            <el-tab-pane label="企业VIP" name="4"></el-tab-pane>
            <el-tab-pane label="黄金VIP" name="5"></el-tab-pane>
          </el-tabs>
        </el-form-item>

        <el-form-item label="" v-if="isuse == 1">
          <el-select v-model="formInline.status" placeholder="企业状态">
            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="" v-if="isuse == 1">
          <el-input v-model="formInline.name" placeholder="企业名称"></el-input>
        </el-form-item>

        <el-form-item v-if="isuse == 1">
          <el-button icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加企业-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/supply/supply/add'">添加企业</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="supply_id" label="企业ID"></el-table-column>
            <el-table-column prop="name" label="企业名称"></el-table-column>
            <el-table-column prop="user_id" label="关联用户ID" width="150"></el-table-column>
            <el-table-column label="账号" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.shop_user">{{scope.row.shop_user.user_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="企业状态">
              <template slot-scope="scope">
                <el-switch
                  @change="setSupplyStatus(scope.row)"
                  v-model="scope.row.status"
                  active-color="#13ce66"
                  inactive-color="#c0c4cc"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="单位类别">
              <template slot-scope="scope">
                <span>{{scope.row.kmd_grade.name}}</span>
              </template>
            </el-table-column>
            <!-- 新增VIP等级列 -->
            <el-table-column label="VIP等级" width="120" v-if="code === 'company'">
              <template slot-scope="scope">
                <el-tag size="small" :type="getVipTagType(scope.row.vip_grade_level)">
                  {{ scope.row.vip_grade_name || '未知' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="150"></el-table-column>
            <el-table-column prop="is_default" label="是否默认">
              <template slot-scope="scope">
                <el-switch
                  @change="setSupplyDefault(scope.row)"
                  v-model="scope.row.is_default"
                  active-color="#13ce66"
                  inactive-color="#c0c4cc">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="product_num" label="商品数量"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="290">
              <template slot-scope="scope">
                <!-- <el-button @click="infoClick(scope.row)" type="text" size="small"
                >我的信息</el-button> -->
                <!-- <el-button @click="aiConfigClick(scope.row)"
                           v-if="scope.row.role != 'wuliu' && scope.row.role != 'jinrong'&& scope.row.role != 'baoguan' && qy_id==0"
                           type="text" size="small">AI配置</el-button> -->

                <span v-if="scope.row.role == 'company'">
                  <!-- <el-button @click="detailClick(scope.row)" type="text" size="small"
                    >公司详情</el-button> -->

                  <el-button @click="productClick(scope.row)" type="text" size="small"
                  >产品/服务</el-button>

                  <el-button @click="cardClick(scope.row)" type="text" size="small"
                  >名片</el-button>

                  <!-- <el-button @click="projectClick(scope.row)" type="text" size="small"
                  >项目投资</el-button> -->

                  <el-button @click="sxtlick(scope.row)" type="text" size="small"
                  >摄像头管理</el-button>

                  <el-button @click="ywylick(scope.row)" type="text" size="small"
                  >业务员管理</el-button>
                </span>

                <span v-if="scope.row.role == 'government'">
                  <!-- <el-button @click="detailClick(scope.row)" type="text" size="small"
                  >详情</el-button> -->

                  <el-button @click="yuanquClick(scope.row)" type="text" size="small"
                  >政府园区</el-button>

                  <el-button @click="zhaoshangClick(scope.row)" type="text" size="small"
                  >招商</el-button>

                  <el-button @click="productClick(scope.row)" type="text" size="small"
                  >产品/服务</el-button>
                </span>

                <span>
                  <el-button @click="cgClick(scope.row)" type="text" size="small"
                  >采购订单</el-button>
                </span>

                <span v-if="scope.row.role == 'shanghui'">
                  <!-- <el-button @click="detailClick(scope.row)" type="text" size="small"
                  >详情</el-button> -->
                  <el-button @click="memberClick(scope.row)" type="text" size="small"
                  >会员</el-button>

                  <el-button @click="cardClick(scope.row)" type="text" size="small"
                  >名片</el-button>

                  <el-button @click="huiyuanClick(scope.row)" type="text" size="small"
                  >核心会员</el-button>

                  <el-button @click="huodongxClick(scope.row)" type="text" size="small"
                  >活动通知</el-button>

                  <el-button @click="productClick(scope.row)" type="text" size="small"
                  >产品/服务</el-button>

                  <el-button @click="huodongClick(scope.row)" type="text" size="small"
                  >历届活动</el-button>
                </span>

                <!-- <el-button @click="noticeClick(scope.row)" type="text" size="small"
                >公告</el-button> -->
                <el-button @click="editClick(scope.row)" type="text" size="small"
                           v-auth="'/plus/supply/supply/edit'">编辑</el-button>

                <el-button @click="deleteClick(scope.row)" v-auth="'/plus/supply/supply/delete'" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!-- AI配置弹窗 -->
    <el-dialog title="AI配置" :visible.sync="openAiConfig" width="500px">
      <el-form :model="aiConfigForm" label-width="100px">
        <el-form-item label="API Key">
          <el-input v-model="aiConfigForm.ai_key" placeholder="请输入AI服务的API Key"></el-input>
        </el-form-item>
        <el-form-item label="扣子workflow_id">
          <el-input v-model="aiConfigForm.kouzi_workflow_id" placeholder="请输入扣子配置流workflow_id"></el-input>
        </el-form-item>
         <el-form-item label="扣子app_id">
          <el-input v-model="aiConfigForm.kouzi_app_id" placeholder="请输入扣子配置流app_id"></el-input>
        </el-form-item>
        <el-form-item label="配置链接">
          <div class="config-link">
            <a :href="aiConfigForm.configUrl" target="_blank">前往AI服务配置页面</a>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openAiConfig = false">取消</el-button>
        <el-button type="primary" @click="saveAiConfig">保存</el-button>
      </div>
    </el-dialog>

    <Info :supply_id='supply_id' v-if='open_info' :open_add="open_info" @close='dialogFormVisible'></Info>
  </div>
</template>

<script>
import SupplyApi from '@/api/supply.js';
import Info from './info';
export default {
  components: {
    Info,
  },
  inject: ['reload'],
  data() {
    return {
      qy_id:0,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      code: this.$route.query.code,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      openAiConfig: false,
      aiConfigForm: {
        supply_id: 0,
        ai_key: '',
        kouzi_workflow_id:0,
        kouzi_app_id:0,
        configUrl: 'https://aifast.aihuixing.com'
      },
      currentSupply: null,
      /*是否打开编辑弹窗*/
      open_edit: false,
      isuse: 0,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        kmd_grade_id: '0', // 默认选中"全部"标签
        grade_id: '0' // VIP等级默认选中"全部"
      },
      status: ['禁用', '启用'],
      supply_id: 0,
      open_info: false,
      kmdGradeArr: [],
      // VIP等级配置
      vipGrades: {
        '1': { name: '游客', level: 0, type: 'info' },
        '3': { name: '个人VIP客户', level: 1, type: 'success' },
        '4': { name: '企业VIP客户', level: 2, type: 'warning' },
        '5': { name: '黄金VIP客户', level: 3, type: 'danger' }
      }
    };
  },
  created() {
    this.getKmdGradeArr();
    var self = this;
    this.getInas({}, function(res) {
      self.isuse = res;
    });
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    getKmdGradeArr() {
      let self = this;
      SupplyApi.getKmdGrade({}, true)
        .then(res => {
          self.kmdGradeArr = res.data;
        });
    },

    // 处理VIP标签点击事件
    handleVipTabClick(tab) {
      this.curPage = 1;
      this.getTableList();
    },

    // 处理单位类别标签点击事件
    handleTabClick(tab) {
      this.curPage = 1;
      this.getTableList();
    },

    // 获取VIP标签类型
    getVipTagType(level) {
      const types = ['info', 'success', 'warning', 'danger'];
      return types[level] || 'info';
    },

    dialogFormVisible() {
      this.open_info = false;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    aiConfigClick(row) {
      this.currentSupply = row;
      this.aiConfigForm.supply_id = row.supply_id;
      this.aiConfigForm.ai_key = row.aikey;
      this.aiConfigForm.kouzi_workflow_id = row.kouzi_workflow_id;
      this.aiConfigForm.kouzi_app_id = row.kouzi_app_id;
      this.openAiConfig = true;
    },

    // 保存AI配置
    saveAiConfig() {
      const params = {
        supply_id: this.aiConfigForm.supply_id,
        api_key: this.aiConfigForm.ai_key,
        kouzi_workflow_id:this.aiConfigForm.kouzi_workflow_id,
        kouzi_app_id:this.aiConfigForm.kouzi_app_id
      };

      SupplyApi.saveAiConfig(params, true)
        .then(response => {
          if (response.code === 1) {
            this.$message.success('AI配置保存成功');
            this.openAiConfig = false;
          } else {
            this.$message.error(response.message || '保存失败');
          }
        })
        .catch(error => {
          this.$message.error('保存失败');
          console.error('保存AI配置失败:', error);
        });
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.code = self.code ? self.code : '';
      Params.list_rows = self.pageSize;

      // 确保传递VIP等级参数
      if (self.code === 'company') {
        Params.grade_id = self.formInline.grade_id;
      }

      self.loading = true;
      SupplyApi.supplyList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.qy_id = data.data.supply_id;
          console.log(self.tableData);
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    infoClick(item) {
      this.supply_id = item.supply_id;
      this.open_info = true;
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加企业*/
    addClick() {
      this.$router.push('/plus/supply/supply/add');
    },

    jumpClick(e) {
      this.$router.push({
        path: '/store/index',
        query: {
          supply_id: e.supply_id
        }
      });
    },

    /*编辑企业*/
    editClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/supply/edit',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    noticeClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/notice/index',
        query: {
          supply_id: supply_id
        }
      });
    },

    detailClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/detail/index',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    memberClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/member/index',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    projectClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/project_investment/index/index',
        query: {
          supply_id: supply_id,
        }
      });
    },

    cardClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/card/cardlist/index',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    huiyuanClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/enterprise/core_members/core_members',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    huodongxClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/shop_activity/index',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    huodongClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/enterprise/activity/index',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    yuanquClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/park/index',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    zhaoshangClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/zhaoshang/index',
        query: {
          supply_id: supply_id,
          role: row.role
        }
      });
    },

    productClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/product/index',
        query: {
          supply_id: supply_id
        }
      });
    },

    cgClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/cg_order/index',
        query: {
          supply_id: supply_id
        }
      });
    },
    sxtlick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/camera/index',
        query: {
          supply_id: supply_id
        }
      });
    },
    ywylick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/staff/index',
        query: {
          supply_id: supply_id
        }
      });
    },

    /*删除企业*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          SupplyApi.delSupply(
            {
              supply_id: row.supply_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '企业删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },

    setSupplyStatus(item) {
      let self = this;
      const originalStatus = item.status;
      const isOpen = item.status === 1;
      const confirmText = isOpen ? '确认开启企业状态吗？' : '确认禁用企业状态吗？';

      self.$confirm(confirmText, '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        let form = {
          'supply_id': item.supply_id,
          'status': item.status,
          'operation': 'setstatus',
        };
        SupplyApi.saveSupply(form, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              const successText = isOpen ? '企业状态开启成功' : '企业状态禁用成功';
              self.$message({ message: successText, type: 'success' });
              self.getTableList();
            } else {
              self.loading = false;
              item.status = originalStatus;
              self.$message.error('操作失败，请重试');
            }
          })
          .catch(error => {
            self.loading = false;
            item.status = originalStatus;
            self.$message.error('操作失败，请重试');
          });
      }).catch(() => {
        // 关键修复：用$nextTick确保视图同步还原
        this.$nextTick(() => {
          // item.status = originalStatus;
          this.getTableList();
          const cancelText = isOpen ? '已取消开启操作' : '已取消禁用操作';
          self.$message({ type: 'info', message: cancelText });
        });
      });
    },
    /*设置默认供应商*/
    setSupplyDefault(item) {
      let self = this;
      let form = {
        'supply_id': item.supply_id,
        'is_default': item.is_default,
        'operation': 'setdefault',
      };
      SupplyApi.saveSupply(form, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    // 获取企业状态（假设的方法）
    getInas(params, callback) {
      // 这里应该是获取企业状态的API调用
      // 模拟返回
      callback(1);
    }
  }
};
</script>

<style scoped>
/* 为Tab标签页添加样式，使其更紧凑 */
.el-tabs__nav-wrap {
  margin-bottom: 0;
}
.el-tabs__header {
  margin-bottom: 0;
}
.el-tabs__item {
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
}

/* VIP等级Tab样式 */
.vip-tabs .el-tabs__item {
  font-size: 12px;
}

/* 配置链接样式 */
.config-link {
  padding: 8px 0;
}
.config-link a {
  color: #409EFF;
  text-decoration: none;
}
.config-link a:hover {
  text-decoration: underline;
}

/* 表格操作按钮间距调整 */
.table-wrap .el-button {
  margin-left: 0;
  margin-right: 5px;
}

/* 分页样式 */
.pagination {
  margin-top: 16px;
  text-align: right;
}

/* 搜索表单样式 */
.common-seach-wrap {
  margin-bottom: 16px;
}

/* 操作栏样式 */
.common-level-rail {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/index.vue